<template>
  <div>
    <navbar />
    <nuxt-child :site-name="name" />
    <section v-if="$route.path === '/'" class="section is-small">
      <div class="container">
        <loan-application />
      </div>
    </section>
    <lazy-hydrate ssr-only>
      <footer-comp logo="false" />
    </lazy-hydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'

export default {
  layout: 'whitelabel',
  components: {
    LazyHydrate,
    footerComp: () => import( '~/whitelabels/components/footer' ),
    loanApplication: () => import( '~/components/loanApplication' ),
    navbar: () => import( '~/whitelabels/components/navbar' )
  },
  head () {
    const desc = 'lainojenyhdistely.fi on lainojen kilpailutukseen erikoistunut palvelu. Vain yhdellä lainahakemuksella voit saada lainatarjouksen useilta eri rahoituslaitoksilta.'
    const theme = '#0d9ef1'
    return {
      title: `${this.name} | Lainahakemus`,
      meta: [
        { hid: 'description', name: 'description', content: desc },
        { hid: 'og:title', name: 'og:title', property: 'og:title', content: this.name },
        { hid: 'og:site_name', name: 'og:site_name', property: 'og:site_name', content: this.name },
        { hid: 'og:description', name: 'og:description', property: 'og:description', content: desc },
        { hid: 'apple-mobile-web-app-title', name: 'apple-mobile-web-app-title', content: this.name },
        { hid: 'theme-color', name: 'theme-color', content: theme }
      ],
      link: [{ rel: 'icon', type: 'image/x-icon', href: require( '~/assets/whitelabels/lainojenyhdistely/favicon.png' ) }]
    }
  },
  data () {
    return {
      name: 'LainojenYhdistely',
      domain: 'lainojenyhdistely.fi'
    }
  }
}
</script>

<style lang="scss">
@import "~assets/whitelabels/scss/_variables.scss";

$wl-primary: #ff5300;
$wl-button-background: $wl-primary;

$wl-body-background: url('~assets/whitelabels/lainojenyhdistely/bg.jpg');

$wl-navbar-background: white;
$wl-navbar-logo-height: 3.5rem;
$wl-navbar-border-bottom: 1px solid rgba(0, 0, 0, 0.1);
$wl-app-border-radius: 0px;

$wl-app-background: hsla(0,0%,100%,1);

$wl-footer-color: white;
$wl-footer-background: #222;

@import "~assets/whitelabels/scss/styles.scss";

.whitelabel.lainojenyhdistely {
  @include whitelabel;
}
</style>
